// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"115":"738386e4","621":"3ca2c741","832":"8f149dc7","954":"abd0fe64"}[chunkId] + ".chunk.css";
};